import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CancelJobMutationVariables = Types.Exact<{
  input: Types.CancelJobInput;
}>;


export type CancelJobMutation = { cancelJob: { success?: boolean | null } };


export const CancelJobDocument = /*#__PURE__*/ gql`
    mutation cancelJob($input: CancelJobInput!) {
  cancelJob(data: $input) {
    success
  }
}
    `;

export function useCancelJobMutation() {
  return Urql.useMutation<CancelJobMutation, CancelJobMutationVariables>(CancelJobDocument);
};